/**
 * global/index.js
 * ===============
 * Globally register all components located in this folder for convenience.
 * Components are registered if their file name match PascalCase.
 * https://vuejs.org/v2/guide/components-registration.html
 * https://vuejs.org/v2/style-guide/#Single-file-component-filename-casing-strongly-recommended
 */

import Vue from 'vue';

// ref: https://webpack.js.org/guides/dependency-management/#require-context
const requireComponent = require.context(
  // Look for files in the current directory
  '.',
  // Whether or not to look in subfolders
  true,
  // The regular expression to match files against
  /[A-Z][a-z]+(?:[A-Z][a-z]+)*\.(js|vue)$/, // PascalCase
);

// For each matching file name...
requireComponent.keys().forEach((fileName) => {
  // Get the component config
  const componentConfig = requireComponent(fileName);

  // Get the PascalCase name of the component
  const componentName = fileName
    // Match filename with or without extension (ex: ./components/MyComponent.vue -> MyComponent.vue)
    .match(/([^\\/]+)$/)[0]
    // Remove the file extension (ex: MyComponent.vue -> MyComponent)
    .replace(/\.\w+$/, '');

  // Globally register the component
  Vue.component(componentName, componentConfig.default || componentConfig);
});
